<template>
  <div class="data_chartmain">
    <div class="databox">
      <div class="dataleftbox">
        <div class="schbox">
          <el-select
            v-model="greenhouseId"
            placeholder="选择大棚"
            size="mini"
            style="width: 100%"
            @change="handleGreenhouseChange"
          >
            <el-option
              v-for="item in greenhouseOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="listbox">
          <div class="listitem">
            <div class="typeitem">
              <div class="left" @click="isallclick">
                <img
                  :src="
                    isall
                      ? require('../assets/img/data/pointed.png')
                      : require('../assets/img/data/point.png')
                  "
                />
                全选
              </div>
            </div>
          </div>
          <div
            class="listitem"
            v-for="item in Object.keys(sbtypedetail)"
            :key="item"
          >
            <div class="typeitem">
              <div class="left">
                <img
                  @click="sbtypeclick(item)"
                  :src="
                    stypeedlist[item]
                      ? require('../assets/img/data/pointed.png')
                      : require('../assets/img/data/point.png')
                  "
                />
                <span @click="sbtypeclick(item, 2)">{{ item }}</span>
              </div>
              <div
                class="el-icon-arrow-down"
                @click="zdclick(type, item)"
              ></div>
            </div>
            <div class="stypebox" v-if="type == item">
              <div
                :class="
                  nowids.indexOf(sitem.id) > -1
                    ? 'stypeitem stypeitemed'
                    : 'stypeitem'
                "
                @click="stypechange(item, sitem.id)"
                v-for="sitem in sbtypedetail[item]"
                :key="sitem.id"
              >
                {{ sitem.deviceName }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="datarightbox">
        <div class="datarbox">
          <el-radio-group v-model="datetype" @change="datetimechange">
            <el-radio-button label="1">实时数据</el-radio-button>
            <el-radio-button label="2">近24小时</el-radio-button>
            <el-radio-button label="3">最近一周</el-radio-button>
            <el-radio-button label="4">最近一月</el-radio-button>
          </el-radio-group>

          <el-date-picker
            v-model="times"
            style="width: 400px"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            @change="timechange"
            end-placeholder="结束日期"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>

          <el-button type="primary" @click="getcheckeddata">查询</el-button>
        </div>
        <div
          class="datachartbox"
          v-loading="chartLoading"
          element-loading-text="数据加载中..."
          element-loading-background="rgba(0, 0, 0, 0.1)"
        >
          <div
            class="chartboxitem"
            v-for="(classifyGroup, classifyIndex) in chartdata"
            :key="`${classifyGroup.deviceClassify}-${classifyIndex}`"
          >
            <div class="titlebox">
              <div class="title">
                {{ classifyGroup.deviceClassifyName }}
              </div>
              <div class="datatypebox">
                <el-checkbox-group
                  v-model="classifyGroup.activeVariableTypes"
                  @change="handleVariableTypeChange(classifyGroup)"
                >
                  <el-checkbox-button
                    v-for="variableType in classifyGroup.variableTypes"
                    :label="variableType.variableTypeName"
                    :key="variableType.variableTypeCode"
                    >{{ variableType.variableTypeName }}</el-checkbox-button
                  >
                </el-checkbox-group>
              </div>
            </div>
            <div class="charts-container">
              <div
                class="chart-wrapper"
                v-for="variableType in classifyGroup.variableTypes"
                :key="variableType.variableTypeCode"
                v-show="
                  classifyGroup.activeVariableTypes.includes(
                    variableType.variableTypeName
                  )
                "
              >
                <div class="chart-title">
                  {{ variableType.variableTypeName }}趋势图
                </div>
                <div class="cbox">
                  <div
                    class="chartbox"
                    :id="getChartDomId(classifyGroup, variableType, 0)"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/axios";
import { baseUrl } from "@/axios/baseUrl";
import {
  getdeviceclassifylist,
  getdatacountbyids,
  getallsblist,
} from "@/api/bot";
import Vue from "vue";
import throttle from "lodash/throttle";
import * as echarts from "echarts";
import dayjs from "dayjs";
//
export default {
  name: "index",
  components: {},
  data() {
    return {
      menu: 0,
      sbtypelist: [],
      sbtypedetail: {},
      type: "",
      times: [
        dayjs().subtract(12, "hour").format("YYYY-MM-DD HH:mm:ss"),
        dayjs().format("YYYY-MM-DD HH:mm:ss"),
      ],
      nowids: [],
      stypeedlist: {},
      // 设备ID到sensorId的映射
      deviceIdToSensorIdMap: {},
      // 设备ID到分类ID的映射
      deviceIdToClassifyMap: {},
      // 设备ID到设备信息（名称、分类名称等）的映射
      deviceIdToInfoMap: {},
      datetype: "1",
      itemsortlist: [],
      isall: false,
      timer: null,
      // 大棚选择
      greenhouseOptions: [],
      greenhouseId: "",
      // 图表数据
      chartdata: [],
      chartLoading: false,
      chartInstances: {},
    };
  },
  computed: {},
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
    if (
      this.getcheckeddata &&
      typeof this.getcheckeddata.cancel === "function"
    ) {
      this.getcheckeddata.cancel();
    }
    this.disposeAllCharts();
  },
  mounted() {
    this.fetchGreenhouseOptions();
  },
  methods: {
    // 获取大棚下拉（参考实时监控页）
    async fetchGreenhouseOptions() {
      const formData = new FormData();
      formData.append("enableStatus", 1);
      const greenhouseRes = await axios.post(
        baseUrl + "/api/basic/greenhouse/selection",
        formData
      );
      this.greenhouseOptions = (greenhouseRes.data || []).map((item) => ({
        label: item.serialNumber,
        value: item.id,
      }));
      // 可选：默认选中第一个大棚并拉设备
      if (this.greenhouseOptions.length) {
        this.greenhouseId = this.greenhouseOptions[0].value;
        this.handleGreenhouseChange();
      }
    },
    // 大棚变化：按 greenhouseId 拉取设备分类并刷新左侧
    async handleGreenhouseChange() {
      // 清空已选
      this.stypeedlist = {};
      this.nowids = [];
      this.isall = false;

      // 同时获取设备分类列表和所有设备列表（包含sensorId）
      let res, allDevicesRes;
      try {
        [res, allDevicesRes] = await Promise.all([
          getdeviceclassifylist({
            greenhouseId: this.greenhouseId,
          }),
          getallsblist(
            this.greenhouseId ? `greenhouseId=${this.greenhouseId}` : ""
          ),
        ]);
      } catch (error) {
        console.error("获取设备列表失败:", error);
        this.sbtypedetail = {};
        this.deviceIdToSensorIdMap = {};
        return;
      }

      const resPayload = Array.isArray(res)
        ? res
        : res && res.data
        ? res.data
        : [];

      // 获取所有设备列表（包含sensorId）
      const allDevicesPayload = Array.isArray(allDevicesRes)
        ? allDevicesRes
        : allDevicesRes && allDevicesRes.data
        ? allDevicesRes.data
        : allDevicesRes && allDevicesRes.success && allDevicesRes.data
        ? allDevicesRes.data
        : [];

      if (Array.isArray(resPayload)) {
        const weatherMeta = this.getWeatherStationVariableMeta();
        // 手动添加棚外气象站的variableTypeList（如果为空）
        resPayload.forEach((group) => {
          if (
            (group.classifyName === "棚外气象站" || group.classifyId === 5) &&
            (!group.variableTypeList || group.variableTypeList.length === 0)
          ) {
            // 参考 data_chart copy.vue 中的数据结构，转换为 API 格式
            group.variableTypeList = weatherMeta.map(
              ({ variableTypeCode, variableTypeName, variableTypeUnit }) => ({
                variableTypeCode,
                variableTypeName,
                variableTypeUnit,
              })
            );
          }
        });

        const resdata = this.transformData(resPayload);
        this.sbtypedetail = resdata.sbtypedetail;

        // 构建设备ID到sensorId的映射
        // 通过设备名称匹配：getdeviceclassifylist返回的name 和 getallsblist返回的deviceName
        this.deviceIdToSensorIdMap = {};
        this.deviceIdToClassifyMap = {};
        this.deviceIdToInfoMap = {};
        const allDevicesMap = {}; // 设备名称到sensorId的映射
        if (Array.isArray(allDevicesPayload)) {
          allDevicesPayload.forEach((device) => {
            // getallsblist返回的id就是sensorId
            if (device.deviceName) {
              allDevicesMap[device.deviceName] = device.id;
            }
          });
        }

        // 遍历设备列表，通过名称匹配找到对应的sensorId
        Object.keys(this.sbtypedetail).forEach((classifyName) => {
          (this.sbtypedetail[classifyName] || []).forEach((dev) => {
            // 通过设备名称匹配：dev.deviceName（来自transformData）对应 allDevicesMap 的 key
            const sensorId = allDevicesMap[dev.deviceName] || dev.id;
            this.deviceIdToSensorIdMap[dev.id] = sensorId;
            const classifyValue = Number(dev.type) || dev.type;
            this.deviceIdToClassifyMap[dev.id] = classifyValue;
            this.deviceIdToInfoMap[dev.id] = {
              deviceName: dev.deviceName,
              classify: classifyValue,
              classifyName,
            };
          });
        });

        console.log("设备ID到sensorId映射:", this.deviceIdToSensorIdMap);

        // 找到包含设备type为3或4的分类名称（从已归整的sbtypedetail中判断）
        const targetClassifyIds = [3, 4];
        const targetClassifyNames = Object.keys(this.sbtypedetail).filter(
          (classifyName) => {
            const devices = this.sbtypedetail[classifyName] || [];
            return devices.some((dev) =>
              targetClassifyIds.includes(Number(dev.type))
            );
          }
        );
        // 默认展开并选中classifyId为3和4的分类
        targetClassifyNames.forEach((item, i) => {
          if (this.sbtypedetail[item] && this.sbtypedetail[item].length) {
            setTimeout(() => this.sbtypeclick(item, 2), 150 * i + 150);
          }
        });
        if (this.timer) {
          clearInterval(this.timer);
        }
        this.timer = setInterval(() => {
          this.getcheckeddata();
        }, 30 * 60 * 1000);
      } else {
        this.sbtypedetail = {};
        this.deviceIdToSensorIdMap = {};
      }
    },
    transformData(originalData) {
      const result = { sbtypedetail: {} };
      const list = Array.isArray(originalData)
        ? originalData
        : originalData && Array.isArray(originalData.data)
        ? originalData.data
        : [];
      if (!list.length) {
        return result;
      }
      // 新结构：[{ classifyId, classifyName, deviceList: [...], variableTypeList: [...] }, ...]
      list.forEach((group) => {
        const classifyName = group.classifyName;
        if (!classifyName) return;
        if (!result.sbtypedetail[classifyName]) {
          result.sbtypedetail[classifyName] = [];
        }
        (group.deviceList || []).forEach((dev) => {
          // sensorId优先使用dev.sensorId，如果没有则使用dev.id
          const sensorId = dev.sensorId || dev.id;
          result.sbtypedetail[classifyName].push({
            id: dev.id,
            createTime: dev.createTime,
            updateTime: dev.updateTime,
            deviceType: dev.deviceType,
            deviceName: dev.name,
            type: dev.classify,
            sensorId: sensorId,
          });
        });
      });

      return result;
    },
    getWeatherStationVariableMeta() {
      return [
        {
          variableTypeCode: "windRank",
          variableTypeName: "风力",
          variableTypeUnit: "级",
        },
        {
          variableTypeCode: "windSpeed",
          variableTypeName: "风速",
          variableTypeUnit: "m/s",
        },
        {
          variableTypeCode: "windDirection",
          variableTypeName: "风向",
          variableTypeUnit: "",
        },
        {
          variableTypeCode: "temp",
          variableTypeName: "温度",
          variableTypeUnit: "℃",
        },
        {
          variableTypeCode: "humi",
          variableTypeName: "湿度",
          variableTypeUnit: "%",
        },
        {
          variableTypeCode: "light",
          variableTypeName: "光照",
          variableTypeUnit: "",
        },
        {
          variableTypeCode: "pressure",
          variableTypeName: "大气压",
          variableTypeUnit: "kPa",
        },
        {
          variableTypeCode: "rainfall",
          variableTypeName: "累计雨量",
          variableTypeUnit: "mm",
        },
        {
          variableTypeCode: "instantRainfall",
          variableTypeName: "瞬时雨量",
          variableTypeUnit: "mm",
        },
        {
          variableTypeCode: "currentRainfall",
          variableTypeName: "当前雨量",
          variableTypeUnit: "mm",
        },
        {
          variableTypeCode: "yesterdayRainfall",
          variableTypeName: "日雨量",
          variableTypeUnit: "mm",
        },
      ];
    },
    normalizeWeatherStationData(rawData, deviceMeta = {}) {
      const metaList = this.getWeatherStationVariableMeta();
      if (!rawData || typeof rawData !== "object") {
        return null;
      }
      let records = [];
      let classifyName = deviceMeta.classifyName || "棚外气象站";
      if (Array.isArray(rawData)) {
        records = rawData;
      } else {
        const targetKey = Object.keys(rawData).find((key) =>
          Array.isArray(rawData[key])
        );
        if (targetKey) {
          classifyName = deviceMeta.classifyName || targetKey;
          records = rawData[targetKey];
        }
      }
      if (!Array.isArray(records)) {
        records = [];
      }
      const deviceName =
        deviceMeta.deviceName ||
        (records[0] && records[0].deviceName) ||
        classifyName;
      const variableDataList = metaList
        .map((meta) => {
          const keyName = meta.valueKey || meta.variableTypeCode;
          const chartList = records
            .map((record) => ({
              key: record.time || record.createTime,
              value: record[keyName],
            }))
            .filter(
              (item) =>
                item.key &&
                typeof item.value !== "undefined" &&
                item.value !== null
            );
          if (!chartList.length) {
            return null;
          }
          return {
            variableTypeCode: meta.variableTypeCode,
            variableTypeName: meta.variableTypeName,
            variableTypeUnit: meta.variableTypeUnit,
            variableUniqueId: `${deviceMeta.deviceId}_${meta.variableTypeCode}`,
            variableHistoryData: {
              chartList,
            },
          };
        })
        .filter(Boolean);
      const activeValue = variableDataList.length
        ? [variableDataList[0].variableUniqueId]
        : [];
      return {
        deviceId: deviceMeta.deviceId,
        id: deviceMeta.deviceId,
        deviceName,
        deviceClassify: 5,
        deviceClassifyName: classifyName,
        variableDataList,
        activeValue,
      };
    },
    isallclick() {
      this.isall = !this.isall;
      Object.keys(this.sbtypedetail).forEach((item, i) => {
        setTimeout(() => {
          this.sbtypeclick(item, this.isall ? 2 : "");
        }, 150 * i);
      });
    },
    zdclick(type, item) {
      if (type == item) {
        this.type = "";
      } else {
        this.type = item;
        this.sbtypeclick(item, 2);
      }
    },
    timechange(times) {
      // console.log(times)
      if (
        new Date(times[1]).getTime() - new Date(times[0]).getTime() >
        2592000000
      ) {
        // 30天的毫秒数
        this.$message.error("最多选择30天");
        this.times = [];
      }
    },
    datetimechange() {
      if (!this.datetype) {
        this.datetype = "1";
      }
      const base = dayjs();
      let start;
      let end;

      switch (this.datetype) {
        case "1":
          start = base.subtract(12, "hour");
          end = base;
          break;
        case "2":
          start = base.subtract(24, "hour");
          end = base;
          break;
        case "3":
          start = base.subtract(7, "day").startOf("day");
          end = base.endOf("day");
          break;
        case "4":
          start = base.subtract(30, "day").startOf("day");
          end = base.endOf("day");
          break;
        default:
          this.datetype = "1";
          start = base.subtract(12, "hour");
          end = base;
          break;
      }

      if (!start || !end) {
        return;
      }

      this.times = [
        start.format("YYYY-MM-DD HH:mm:ss"),
        end.format("YYYY-MM-DD HH:mm:ss"),
      ];
    },

    sbtypeclick(e, t) {
      this.type = e;
      if (!this.stypeedlist[e] || t === 2) {
        Vue.set(this.stypeedlist, e, []);
      } else {
        this.stypeedlist[e].forEach((item) => {
          const dindex = this.nowids.indexOf(item);
          this.nowids.splice(dindex, 1);
        });
        this.$delete(this.stypeedlist, e);
        return;
      }

      this.sbtypedetail[e].forEach((item) => {
        this.stypechange(e, item.id, 1);
      });
    },
    stypechange(type, sid, t) {
      this.type = type;
      const data = this.stypeedlist[type];
      const index = data.indexOf(sid);
      const dindex = this.nowids.indexOf(sid);
      if (index > -1) {
        if (t && t == 1) return;
        data.splice(index, 1); // 存在则删除
        this.nowids.splice(dindex, 1);
      } else {
        data.push(sid); // 不存在则添加
        this.nowids.push(sid); // 不存在则添加
      }
      this.stypeedlist[type] = [...data];
      this.getcheckeddata();
    },
    getcheckeddata: throttle(async function () {
      const deviceIds = Object.keys(this.stypeedlist).reduce((acc, key) => {
        const ids = this.stypeedlist[key] || [];
        return acc.concat(ids);
      }, []);

      if (!deviceIds.length) {
        this.disposeAllCharts();
        this.chartdata = [];
        this.chartLoading = false;
        return;
      }

      this.chartLoading = true;
      try {
        const res = await Promise.all(
          deviceIds.map((deviceId) => {
            // 从映射中获取对应的sensorId，如果没有则使用deviceId
            const sensorId = this.deviceIdToSensorIdMap[deviceId] || deviceId;
            return getdatacountbyids({
              chronoUnit:
                this.datetype == "1"
                  ? "MINUTES"
                  : this.datetype == "2"
                  ? "DAYS"
                  : this.datetype == "3"
                  ? "WEEKS"
                  : "MONTHS",
              startTime: this.times[0],
              endTime: this.times[1],
              deviceId,
              sensorId: sensorId,
              dataType: this.datetype == 4 ? 3 : this.datetype,
            });
          })
        );

        const normalized = res
          .map((item, index) => {
            const deviceId = deviceIds[index];
            const deviceInfo = this.deviceIdToInfoMap[deviceId] || {};
            const classify = Number(deviceInfo.classify);
            const dataItem = (item && item.data) || {};
            if (classify === 5) {
              return this.normalizeWeatherStationData(dataItem, {
                deviceId,
                deviceName: deviceInfo.deviceName,
                classifyName: deviceInfo.classifyName,
              });
            }
            const variableDataList = Array.isArray(dataItem.variableDataList)
              ? dataItem.variableDataList
              : [];
            let activeValue = dataItem.activeValue;
            if (!Array.isArray(activeValue)) {
              if (activeValue && typeof activeValue !== "boolean") {
                activeValue = [activeValue];
              } else if (variableDataList.length) {
                activeValue = [variableDataList[0].variableUniqueId];
              } else {
                activeValue = [];
              }
            }
            return {
              ...dataItem,
              deviceId: dataItem.deviceId || deviceId,
              deviceName: dataItem.deviceName || deviceInfo.deviceName,
              deviceClassify: dataItem.deviceClassify || classify,
              deviceClassifyName:
                dataItem.deviceClassifyName || deviceInfo.classifyName,
              variableDataList,
              activeValue: [...activeValue],
              id: dataItem.deviceId || dataItem.id || deviceId,
            };
          })
          .filter((item) => item);
        this.disposeAllCharts();

        // 按deviceClassify和variableDataList重新组织数据
        this.chartdata = this.groupDataByClassifyAndVariable(normalized);
        console.log("重新组织的数据", normalized);

        this.$nextTick(() => {
          this.renderAllCharts();
        });
      } catch (err) {
        console.log(err);
      } finally {
        this.chartLoading = false;
      }
    }, 800),
    // 按deviceClassifyName分组，每个分组下有多个variableTypeName
    groupDataByClassifyAndVariable(normalized) {
      const classifyMap = {};

      normalized.forEach((device) => {
        const deviceClassify = device.deviceClassify;
        const deviceClassifyName = device.deviceClassifyName || "未知分类";
        const variableDataList = device.variableDataList || [];
        const deviceId = device.deviceId || device.id;

        // 按deviceClassifyName分组
        if (!classifyMap[deviceClassifyName]) {
          classifyMap[deviceClassifyName] = {
            deviceClassify,
            deviceClassifyName,
            variableTypes: [],
            activeVariableTypes: [], // 存储选中的variableTypeName列表
          };
        }

        // 遍历该设备的所有变量类型
        variableDataList.forEach((variable) => {
          const variableTypeName = variable.variableTypeName;
          const variableTypeCode = variable.variableTypeCode;

          // 查找是否已存在该变量类型
          let variableTypeItem = classifyMap[
            deviceClassifyName
          ].variableTypes.find(
            (vt) => vt.variableTypeCode === variableTypeCode
          );

          if (!variableTypeItem) {
            // 如果不存在，创建新的变量类型项
            variableTypeItem = {
              variableTypeCode,
              variableTypeName,
              variableTypeUnit: variable.variableTypeUnit || "",
              upperLimit: variable.upperLimit,
              lowerLimit: variable.lowerLimit,
              devices: [],
            };
            classifyMap[deviceClassifyName].variableTypes.push(
              variableTypeItem
            );
            // 根据deviceClassify设置默认选中的变量类型
            const currentLength = classifyMap[deviceClassifyName].variableTypes.length;
            const classifyId = classifyMap[deviceClassifyName].deviceClassify;
            
            // classifyId为3时，默认选中第2、3个；classifyId为4时，默认选中第2、4个
            if (classifyId === 3 && (currentLength === 2 || currentLength === 3)) {
              classifyMap[deviceClassifyName].activeVariableTypes.push(variableTypeName);
            } else if (classifyId === 4 && (currentLength === 2 || currentLength === 4)) {
              classifyMap[deviceClassifyName].activeVariableTypes.push(variableTypeName);
            } else if (classifyId !== 3 && classifyId !== 4 && currentLength === 1) {
              // 其他分类默认选中第一个
              classifyMap[deviceClassifyName].activeVariableTypes.push(variableTypeName);
            }
          } else {
            // 如果已存在，但上下限为空，则尝试从当前设备获取
            if (variableTypeItem.upperLimit === null || variableTypeItem.upperLimit === undefined) {
              if (variable.upperLimit !== null && variable.upperLimit !== undefined) {
                variableTypeItem.upperLimit = variable.upperLimit;
              }
            }
            if (variableTypeItem.lowerLimit === null || variableTypeItem.lowerLimit === undefined) {
              if (variable.lowerLimit !== null && variable.lowerLimit !== undefined) {
                variableTypeItem.lowerLimit = variable.lowerLimit;
              }
            }
          }

          // 添加设备数据到该变量类型
          const chartList = variable.variableHistoryData?.chartList || [];
          variableTypeItem.devices.push({
            deviceId,
            deviceName: device.deviceName,
            chartList,
          });
        });
      });

      // 按deviceClassify排序
      return Object.values(classifyMap).sort((a, b) => {
        return (a.deviceClassify || 0) - (b.deviceClassify || 0);
      });
    },
    handleVariableTypeChange(classifyGroup) {
      this.$nextTick(() => {
        this.renderClassifyGroup(classifyGroup);
      });
    },
    getChartDomId(classifyGroup, variableType, index) {
      return `chartbox-${classifyGroup.deviceClassify}-${variableType.variableTypeCode}-${index}`;
    },
    renderAllCharts() {
      this.chartdata.forEach((classifyGroup) => {
        this.renderClassifyGroup(classifyGroup);
      });
    },
    renderClassifyGroup(classifyGroup) {
      if (!classifyGroup) return;

      // 遍历该分类下的所有变量类型
      classifyGroup.variableTypes.forEach((variableType) => {
        // 只渲染选中的变量类型
        if (
          !classifyGroup.activeVariableTypes.includes(
            variableType.variableTypeName
          )
        ) {
          // 如果未选中，销毁对应的图表
          const chartKey = `${classifyGroup.deviceClassify}-${variableType.variableTypeCode}`;
          this.disposeChartGroup(chartKey);
          return;
        }

        const chartKey = `${classifyGroup.deviceClassify}-${variableType.variableTypeCode}`;
        this.disposeChartGroup(chartKey);

        // 获取该变量类型下的所有设备（默认显示所有设备）
        const devices = variableType.devices || [];
        if (!devices.length) {
          return;
        }

        const domId = this.getChartDomId(classifyGroup, variableType, 0);
        const el = document.getElementById(domId);
        if (!el) return;

        const chartInstance = echarts.init(el);
        chartInstance.setOption(
          this.buildStackedChartOption(variableType, devices)
        );

        this.$set(this.chartInstances, chartKey, [chartInstance]);
      });
    },
    buildStackedChartOption(variableType, devices) {
      const { variableTypeName, variableTypeUnit, upperLimit, lowerLimit } =
        variableType;

      if (!devices || !devices.length) {
        return {};
      }

      // 收集所有时间点
      const allTimes = new Set();
      devices.forEach((device) => {
        (device.chartList || []).forEach((item) => {
          if (item.key) {
            allTimes.add(item.key);
          }
        });
      });

      // 排序时间点
      const times = Array.from(allTimes).sort();

      // 构建 markLine 配置（用于显示上下限）
      const markLineData = [];
      if (upperLimit !== null && upperLimit !== undefined) {
        markLineData.push({
          yAxis: upperLimit,
          name: "上限",
          label: {
            formatter: `上限 ${upperLimit}`,
            position: "start",
          },
          lineStyle: {
            color: "red",
            type: "dashed",
            width: 2,
          }, 
        });
      }
      if (lowerLimit !== null && lowerLimit !== undefined) {
        markLineData.push({
          yAxis: lowerLimit,
          name: "下限",
          label: {
            formatter: `下限 ${lowerLimit}`,
            position: "start",
          },
          lineStyle: {
            color: "#faad14",
            width: 2,
          },
        });
      }

      // 为每个设备构建数据序列
      const series = devices.map((device, index) => {
        const deviceData = new Map();
        (device.chartList || []).forEach((item) => {
          deviceData.set(item.key, item.value);
        });

        // 按时间顺序填充数据，缺失值用null
        const values = times.map((time) => {
          const value = deviceData.get(time);
          return value !== undefined && value !== null ? value : null;
        });

        const seriesItem = {
          name: device.deviceName,
          type: "line",
          smooth: true,
          data: values,
          symbol: "circle",
          symbolSize: 6,
          lineStyle: {
            width: 2,
          },
          areaStyle: {
            opacity: 0.1,
          },
        };

        // 将 markLine 添加到第一个 series 中
        if (index === 0 && markLineData.length > 0) {
          seriesItem.markLine = {
            symbol: "none",
            data: markLineData,
          };
        }

        return seriesItem;
      });

      // 构建图例数据
      const legendData = devices.map((device) => device.deviceName);

      return {
        legend: {
          data: legendData,
          top: 10,
          textStyle: {
            color: "#ffffff",
          },
          formatter: (name) => {
            const unit = variableTypeUnit ? ` ${variableTypeUnit}` : "";
            return unit ? `${name}(${unit})` : name;
          },
        },
        tooltip: {
          trigger: "axis",
          formatter: (params) => {
            const unit = variableTypeUnit ? ` ${variableTypeUnit}` : "";
            const items = Array.isArray(params) ? params : [params];
            const title =
              (items[0] && (items[0].axisValueLabel || items[0].axisValue)) ||
              "";
            const lines = items
              .filter((p) => p.data !== null && p.data !== undefined)
              .map((p) => `${p.marker}${p.seriesName}: ${p.data}${unit}`);
            return lines.length ? [title, ...lines].join("<br/>") : title;
          },
        },
        grid: { top: 80, left: 60, right: 30, bottom: 100 },
        xAxis: {
          type: "category",
          data: times,
          boundaryGap: false,
          axisLabel: {
            color: "#ffffff90",
          },
          axisLine: {
            lineStyle: {
              color: "#2c5aa0",
            },
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#ffffff90",
          },
          splitLine: {
            lineStyle: {
              color: "rgba(44, 90, 160, 0.3)",
            },
          },
        },
        dataZoom: [
          {
            type: "slider",
            xAxisIndex: 0,
            bottom: 40,
            height: 20,
            handleSize: 10,
            backgroundColor: "rgba(44, 90, 160, 0.2)",
            borderColor: "rgba(44, 90, 160, 0.6)",
            textStyle: {
              color: "#ffffff90",
            },
            fillerColor: "rgba(38, 128, 221, 0.3)",
          },
          {
            type: "inside",
            xAxisIndex: 0,
          },
        ],
        series,
      };
    },
    disposeChartGroup(chartKey) {
      const instances = this.chartInstances[chartKey] || [];
      instances.forEach((instance) => {
        if (instance && !instance.isDisposed()) {
          instance.dispose();
        }
      });
      this.$set(this.chartInstances, chartKey, []);
    },
    disposeAllCharts() {
      Object.keys(this.chartInstances).forEach((chartKey) => {
        this.disposeChartGroup(chartKey);
      });
      this.chartInstances = {};
    },
  },
};
</script>

<style scoped lang="less">
@font-face {
  font-family: "title";
  src: url("../assets/font/title.ttf");
}

.data_chartmain {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #030a2e;

  .datamenubox {
    margin: 10px;
    height: 50px;
    display: flex;
    align-items: center;
    padding-left: 10px;

    .datamenuitem {
      padding: 15px 30px;
      color: #fff;
      font-size: 20px;
      cursor: pointer;
      background-color: #203663;
    }

    .died {
      background-color: #0691ed;
    }
  }

  .databox {
    margin: 10px;
    width: calc(100% - 10px);
    height: calc(100% - 10px);
    display: flex;

    .dataleftbox {
      width: 300px;
      height: 100%;
      border: 1px solid #99afcc20;
      padding: 10px;

      .schbox {
        width: 100%;
        height: 35px;
        display: flex;
        justify-content: space-between;

        input {
          background-color: transparent;
          border: 1px solid #2680dd;
          width: calc(100% - 100px);
          height: 35px;
          color: #fff;
          padding-left: 12px;
        }

        .schbtn {
          width: 90px;
          height: 35px;
          font-size: 16px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 4px;
          color: #fff;
          background-color: #2e91ff;
        }
      }

      .listbox {
        width: 100%;
        height: calc(100% - 50px);
        margin-top: 20px;

        .listitem {
          width: 100%;
          color: #2680dd;
          font-size: 20px;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          font-weight: bold;
          cursor: pointer;

          .typeitem {
            margin: 5px 0;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .left {
              display: flex;
              align-items: center;

              img {
                width: 40px;
                margin-top: 5px;
              }
            }
          }

          .stypebox {
            padding-left: 10px;
            font-size: 16px;
            width: calc(100% - 10px);

            .stypeitem {
              width: 100%;
              margin: 10px 0;
              padding: 10px;
              background: rgba(7, 52, 85, 0.6);
              border-radius: 0px 0px 0px 0px;
            }

            .stypeitemed {
              background: rgba(7, 52, 85, 0.6);
              box-shadow: inset 0px 0px 7px 0px #00c2ff;
              border-radius: 0px 0px 0px 0px;
            }
          }
        }
      }
    }

    .datarightbox {
      width: calc(100% - 300px);
      margin-left: 20px;
      height: 100%;

      .datarbox {
        display: flex;
        align-items: center;
        justify-content: center;

        padding-top: 5px;
      }
    }
  }
}

/deep/ .el-radio-button__inner {
  color: #e7f0ff;
  background: #03072e;
  border: 1px solid #2680dd;
  font-size: 16px;
}

/deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #fff;
  background: #2680dd;
  border: 1px solid #2680dd;
}

/deep/ .el-input__inner,
/deep/ .el-range-input {
  background-color: transparent;
}

/deep/ .el-input__inner {
  border: 1px solid #2680dd;
  margin: 0 10px;
}

/deep/ .el-date-editor .el-range-separator {
  color: #fff;
}

/deep/ .el-date-editor .el-range-input {
  color: #fff;
  font-size: 16px;
}
.datachartbox {
  width: 100%;
  height: calc(100% - 55px);
  margin-top: 10px;
  overflow-y: auto;

  .chartboxitem {
    max-width: 100%;
    border: 1px solid #99afcc20;
    overflow-y: auto;
    margin-top: 10px;
  }
  &:first-child {
    margin-top: 0px;
  }
  .titlebox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    position: relative;
    width: 100%;
    z-index: 3;

    .title {
      font-size: 22px;
      color: #fff;
    }
  }
  .charts-container {
    display: flex;
    flex-wrap: wrap;
    padding: 10px;
    gap: 10px;

    .chart-wrapper {
      flex: 1;
      min-width: calc(50% - 5px);
      border: 1px solid #99afcc20;
      padding: 10px;

      .chart-title {
        font-size: 18px;
        color: #fff;
        text-align: center;
        margin-bottom: 10px;
        font-weight: bold;
      }

      .cbox {
        height: calc(100% - 50px);
        padding: 0 10px;

        .chartbox {
          width: 100%;
          height: 400px;
        }
      }
    }
  }
  .cbox {
    height: calc(100% - 70px);
    padding: 0 10px;

    .chartbox {
      width: 100%;
      height: 400px;
    }
  }
}
</style>
